import * as Auth from '../services/auth';
import * as Form from '../services/form';
import * as englishForm from '../services/englishform';
import * as japaneseForm from '../services/japaneseform';
import * as germanForm from '../services/germanform';
import * as chineseForm from '../services/chineseform';
import * as Upload from '../services/upload';
import * as Menu from '../services/menu';
import * as Employee from '../services/employee';
import Role from '../services/role';
import User from '../services/user';
//import Config from '../services/config';
import * as Config from '../services/config';
import * as CodeDt from '../services/codeDt';
import * as SystemNews from '../services/systemNews';


export const AuthService = Auth;
export const FormService = Form;
export const englishFormService = englishForm;
export const japaneseFormService = japaneseForm;
export const germanFormService = germanForm;
export const chineseFormService = chineseForm;
export const UploadService = Upload;
export const MenuService = Menu;
export const RoleService = Role;
export const UserService = User;
export const EmployeeService = Employee;
export const ConfigService = Config;
export const CodeDtService = CodeDt;
export const SystemNewsService = SystemNews;